// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE];
const templatesApi = {
  getTemplates(payload) {
    return client.get(`/creative-template/creative-templates/search?${payload}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCreativeTypes() {
    return client.get('/creative/creative-types')
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getTemplate(id) {
    return client.get(`/creative-template/creative-templates/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  createTemplate(templateForm) {
    return client.post('/creative-template/creative-templates', templateForm);
  },
  updateTemplate(id, templateForm) {
    return client.put(`/creative-template/creative-templates/${id}`, templateForm);
  },
  getTemplateGroups() {
    return client.get('/creative-template/template-groups')
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  createTemplateGroup(groupName) {
    return client.post('/creative-template/template-groups', groupName);
  },
  getTemplatesInGroupId(id) {
    return client.get(`/creative-template/creative-templates?templateGroupId=${id}`)
      .then((response) => response.data);
  },
};
export default templatesApi;
